module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_gardenchapel-665ffbd8fce8830982346ff87bf1e4fa.jpg";